import isEmpty from "lodash/isEmpty"
import join from "lodash/join"
import commonApiAuthRequest from "../apiAuthRequest"
import { TOIR_SERVICE_URL } from "./constants"

/*
  Спека
  https://next.stoplight.io/infotech-group/toir/version%2F1.0/inspection-service.oas2.yml?view=%2Freference%2Fcheck%2Ffindchecks
*/

const checksFetch = visitIds =>
  commonApiAuthRequest({
    url: `${TOIR_SERVICE_URL}/check`,
    params: { query: `visitId=in=(${join(visitIds, `,`)})` },
  })

/**
 * makes request to get defect list by visitid
 *
 * @param {number} visitid
 * @return {Array.<Object>} response - array of checks
 */
export const getActualChecks = async visitIds => {
  if (!visitIds || isEmpty(visitIds)) {
    return undefined
  }

  const { data: checks } = await checksFetch(visitIds)

  return checks
}
